import { userDrugActions } from '../reducers/userDrugSlice';
import { getSavedDrugs } from '../services/Api/SavedDrugs/savedDrugService';
import { fetchSavedCoupons } from '../services/Api/SaveCoupon/SaveCouponService';

export const fetchSavedDrugs = () => {
  return async dispatch => {
    const savedDrugs = await getSavedDrugs();
    dispatch(
      userDrugActions.fetchSavedDrugs({
        savedDrugs
      })
    );
  };
};

export const setSavedDrugs = data => {
  return async dispatch => {
    dispatch(
      userDrugActions.fetchSavedDrugs({
        savedDrugs: data
      })
    );
  };
};

export const getSavedCoupons = () => {
  return async dispatch => {
    const savedCoupons = await fetchSavedCoupons();
    dispatch(
      userDrugActions.fetchSavedCoupons({
        savedCoupons
      })
    );
  };
};

export const setSavedCoupons = data => {
  return async dispatch => {
    dispatch(
      userDrugActions.fetchSavedCoupons({
        savedCoupons: data
      })
    );
  };
};

export const setCouponData = coupon => {
  return async dispatch => {
    dispatch(
      userDrugActions.setCouponData({
        coupon
      })
    );
  };
};

export const setSavedLinkClick = savedLinkClicked => {
  return async dispatch => {
    dispatch(
      userDrugActions.setSavedLinkClick({
        savedLinkClicked
      })
    );
  };
};

export const setSavedDrugClick = savedDrugClicked => {
  return async dispatch => {
    dispatch(
      userDrugActions.setSavedDrugClick({
        savedDrugClicked
      })
    );
  };
};

export const setIsFetchDrug = isFetchDrug => {
  return async dispatch => {
    dispatch(
      userDrugActions.setIsFetchDrug({
        isFetchDrug
      })
    );
  };
};
